const redactorTables = [...document.querySelectorAll('.fullWidth table')]

if (redactorTables.length) {
    const domparser = new DOMParser()
    redactorTables.forEach(function applyWrappingElement (redactorTable) {
        const originalHTML = redactorTable.outerHTML
        const newHTML = `<div class="tableFix">${originalHTML}</div>`
        const newNode = domparser.parseFromString(newHTML, 'text/html').querySelector('.tableFix')

        redactorTable.after(newNode)
        redactorTable.remove()
    })
}
